var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyC4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_229",
    "data-name": "Group 229",
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.124,
    height: 164.618,
    viewBox: "0 0 181.124 164.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M152.823,60.422V36.211a2.894,2.894,0,0,1,2.894-2.894h119.9a2.9,2.9,0,0,1,2.894,2.894v91.539a2.9,2.9,0,0,1-2.894,2.894H215.79a2.86,2.86,0,1,0,0,5.719h59.83a8.612,8.612,0,0,0,8.614-8.614V36.211A8.612,8.612,0,0,0,275.62,27.6h-119.9a8.612,8.612,0,0,0-8.614,8.614V60.422a2.86,2.86,0,1,0,5.719,0Z",
    transform: "translate(-103.11 -27.597)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M371.879,425.892v40.635a2.86,2.86,0,1,0,5.719,0V425.892a2.86,2.86,0,1,0-5.719,0Z",
    transform: "translate(-260.661 -304.769)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M505.058,316.3H472.925a6.7,6.7,0,0,0-6.7,6.7V335.86a2.86,2.86,0,0,0,5.719,0V322.991a.976.976,0,0,1,.976-.976h32.133a2.86,2.86,0,0,0,0-5.72Z",
    transform: "translate(-326.794 -229.954)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M216.563,97.806h39.489a2.86,2.86,0,0,0,0-5.719H216.563a2.86,2.86,0,0,0,0,5.719Z",
    transform: "translate(-149.791 -72.8)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M216.563,147.219h94.614a2.86,2.86,0,0,0,0-5.719H216.563a2.86,2.86,0,0,0,0,5.719Z",
    transform: "translate(-149.791 -107.435)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M274.435,196.638H293.1a2.86,2.86,0,1,0,0-5.719H274.435a2.86,2.86,0,0,0,0,5.719Z",
    transform: "translate(-190.355 -142.074)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M427.658,264.143h29.518a2.86,2.86,0,0,0,0-5.719H427.658a2.86,2.86,0,0,0,0,5.719Z",
    transform: "translate(-297.754 -189.39)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M451.278,196.638h23.96a2.86,2.86,0,0,0,0-5.719h-23.96a2.86,2.86,0,0,0,0,5.719Z",
    transform: "translate(-314.31 -142.074)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M90.883,157.927a26.305,26.305,0,1,0,26.305,26.305A26.317,26.317,0,0,0,90.883,157.927Zm0,5.72A20.585,20.585,0,1,1,70.3,184.232,20.6,20.6,0,0,1,90.883,163.647Z",
    transform: "translate(-45.265 -118.949)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M93.436,316.919l-10.7,10.263a2.9,2.9,0,0,1-2,.8H31.219A25.939,25.939,0,0,0,5.644,349.6c-1.9,11.245-4.185,24.744-5.523,32.658a8.614,8.614,0,0,0,8.494,10.05h53a8.615,8.615,0,0,0,8.616-8.614V356.631a.973.973,0,0,1,.976-.976H83.915a22.651,22.651,0,0,0,15.681-6.3c3.8-3.642,8.822-8.461,12.993-12.465a13.835,13.835,0,0,0,.484-19.478l-.158-.164a13.83,13.83,0,0,0-19.48-.324ZM86.7,331.308l10.7-10.263a8.115,8.115,0,0,1,11.424.191l.093.1a8.11,8.11,0,0,1-.284,11.422c-4.172,4-9.2,8.823-12.993,12.465a16.931,16.931,0,0,1-11.722,4.713H71.209a6.7,6.7,0,0,0-6.7,6.7v27.064a2.9,2.9,0,0,1-2.894,2.894h-53a2.9,2.9,0,0,1-2.854-3.377l5.523-32.658a20.22,20.22,0,0,1,19.935-16.848H80.734A8.618,8.618,0,0,0,86.7,331.308Z",
    transform: "translate(-0.001 -227.691)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M72.565,492.91l5-29.58a2.86,2.86,0,0,0-5.64-.953l-5,29.58a2.86,2.86,0,1,0,5.64.953Z",
    transform: "translate(-46.882 -330.676)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M79.608,506.291h17.2a.976.976,0,0,1,.976.976v13.609a2.86,2.86,0,0,0,5.719,0V507.267a6.7,6.7,0,0,0-6.7-6.7h-17.2a2.86,2.86,0,0,0,0,5.72Z",
    transform: "translate(-53.795 -359.118)",
    fill: "#170d65",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M351.321,231.671l11.846-37.024a2.86,2.86,0,0,0-5.449-1.742l-11.844,37.024a2.86,2.86,0,1,0,5.447,1.742Z",
    transform: "translate(-242.337 -142.072)",
    fill: "#170d65",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyC4);
export default __webpack_public_path__ + "static/media/whyC4.fda486c6fc99ebc2623cb4f4d82a6a37.svg";
export { ForwardRef as ReactComponent };